import { SMSTemplatesManager } from '../../components/sms/sms_template_manager';

export default function SMSTemplateSettings() {

    const SMSTemplates  = new SMSTemplatesManager();
    const { Handlebars, bugsnagClient } = window;

    let rowTemplate = Handlebars.compile(document.getElementById('sms-template-row-template').innerHTML, { noEscape: true });


    const SMSTemplatesList = function () {
        const _this = $(this);

        let instanceVars = {
            templates: {},
            initialise: function () {
                let t = this;
                SMSTemplates.on('got_templates', function (templates) {
                    t.populateTemplates(templates);
                    t.redraw();
                });
                SMSTemplates.on('failed_got_templates', function () {
                    t.showGeneralError(_t('seller_settings_comms:error.failed-to-load'))
                });
                SMSTemplates.getTemplates();
                this.addListeners();
            },

            makeTemplate: function(templateData) {
                let t = this;
                let template;
                template = SMSTemplates.newTemplate(templateData);
                template.on('updated',  function (updatedTemplate) {
                    t.addTemplate(updatedTemplate);
                    t.redraw();
                });
                return template;
            },

            populateTemplates: function (templates) {
                templates.forEach((templateData) => {
                    this.addTemplate(this.makeTemplate(templateData));
            })
            },

            addTemplate: function (template) {
                this.templates[template.id] = template;
            },

            findTemplate: function (templateId) {
                let template = null;
                if (typeof templateId !== 'undefined') {
                    template = this.templates[templateId];
                }
                if (typeof template === 'undefined') {
                    template = null;
                }
                return template;
            },

            createTemplate: function () {
                this.editTemplate()
            },

            editTemplate: function (templateId) {
                let template = this.findTemplate(templateId)
                if (template === null) {
                    template = this.makeTemplate();
                }
                template.loadEditModal();
            },

            deleteTemplate: function (templateId) {
                let template = this.findTemplate(templateId);
                let t = this;
                let callback = function () {
                    delete t.templates[templateId];
                    t.redraw();
                };
                if (template === null) {
                    callback();
                } else {
                    template.delete(callback);
                }
            },

            redraw: function () {
                let length = Object.keys(this.templates).length;

                $('.sms-template-list').html('');

                if (length === 0) {
                    $('.sms-templates-container').removeClass('has-items');
                } else {
                    $('.sms-templates-container').addClass('has-items');
                }

                Object.values(this.templates).forEach((template) => {
                    $('.sms-template-list').append(rowTemplate(template.getData()));
            });

                $('.waiting').removeClass('waiting');
            },

            showGeneralError(error) {
                $('.sms-templates-container').prepend(
                    '<div class="error-box text-center mb-3">' +
                    '<p class="error mb-0">' + error + '</p>' +
                    '</div>'
                )
            },

            addListeners: function () {
                let t = this;

                $('#sms_templates').on('click touchstart', '.delete-item-link', function (e) {
                    e.preventDefault();
                    t.deleteTemplate($(e.currentTarget).closest('.sms-template-row').data('id'));
                });

                $('#sms_templates').on('click touchstart', '.add-item-link', function (e) {
                    e.preventDefault();
                    t.createTemplate();
                });

                $('#sms_templates').on('click touchstart', '.edit-item-link', function (e) {
                    e.preventDefault();
                    t.editTemplate($(e.currentTarget).closest('.sms-template-row').data('id'));
                });

                $('#sms_templates').on('click', '.js-menu-show-options', function (e) {
                    e.preventDefault();
                    let scope = $(this);

                    if (scope.hasClass('open')) {
                        scope.removeClass('open');
                    } else {
                        scope.addClass('open');

                        window.setTimeout(function () {
                            $('body').on('click.closemenu', function () {
                                scope.removeClass('open');
                                $('body').off('click.closemenu');
                                $('body').off('touchend.closemenu');
                            });
                            $('body').on('touchend.closemenu', function (e) {
                                $('body').off('click.closemenu');
                                $('body').off('touchend.closemenu');
                                scope.removeClass('open');
                            });
                        }, 10)
                    }
                });
            }
        };

        Object.assign(_this, instanceVars);
        return _this;

    };

    SMSTemplatesList().initialise();

}
